import { Button, Dialog } from '@mui/material';
import CloseModalButton from '../../../../components/CloseModalButton';
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from '../../../../components/Dialog.styled';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { WaterlineTestResult } from '../types';
import { useState } from 'react';
import { addError } from '../../../../redux/alerts';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { deleteInOfficeWaterlineTestResult } from '../../../../services/waterlineService';
import { selectCurrentCustomerNumber } from '../../../../redux/customer';

interface DeleteTestResultModalProps {
  onClose: (refresh?: boolean) => void;
  isOpen: boolean;
  testResult: WaterlineTestResult | null;
}

const DeleteTestResultModal: React.FC<DeleteTestResultModalProps> = ({ onClose, isOpen, testResult }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const customerNumber = useAppSelector(selectCurrentCustomerNumber);

  const handleSubmit = async () => {
    setLoading(true);

    if (!testResult) {
      onClose(false);
      return;
    }

    try {
      await deleteInOfficeWaterlineTestResult(customerNumber, testResult.test_result_id);
      onClose(true);
    } catch (error) {
      const message = 'There was an error deleting the In-Office Result';
      console.error(message);
      dispatch(addError(message));
      onClose(false);
    }

    setLoading(false);
  };

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} fullWidth>
      <CloseModalButton handleClose={() => onClose(false)} />
      <StyledDialogTitle>Delete In-Office Result</StyledDialogTitle>
      <StyledDialogContent>
        <div className="flex flex-center m-b-16">
          <DeleteIcon fontSize="large" />
        </div>
        <div className="m-b-16 center">
          Are you sure you want to delete the logged In-Office Result?
        </div>
      </StyledDialogContent>
      <StyledDialogFooter>
        <Button onClick={() => onClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          Delete
        </Button>
      </StyledDialogFooter>
    </Dialog>
  );
};

export default DeleteTestResultModal;
